export default class PersonnelDocumentDto {
    note?: string;
    updateDate?: boolean;
    date?: string;
    s3Id?: number;
    docId?: number; // docId here corresponds to PK for LM_INSURANCE / LM_PAPERWORK
    lmNo?: number; // lmNo here correponds to PK for LM_RESUME_BLOB
}


// WEBPACK FOOTER //
// ./src/models/personnel/PersonnelDocumentDto.ts